import {useCallback} from 'react';
import useUpdatePayinSessionMutation from 'src/api/graphql/useUpdatePayinSessionMutation';
import {getStore} from 'src/v2/state/store';
import {convertGraphQlToExternalPaymentDetails} from 'src/v2/util/convertGraphQlToStoreState';

type UpdateParams = {
  paymentUrl: string;
  paymentQrCode: string;
  paymentId: string;
};

export const useUpdateSessionOnExchangeSelect = (): ((
  params: UpdateParams,
) => Promise<void>) => {
  const store = getStore();
  const [updatePayinSessionMutation] = useUpdatePayinSessionMutation();
  const sessionId = store.useSelector((state) => state.id);
  const clientSecret = store.useSelector((state) => state.clientSecret);

  const updateSession = useCallback(
    async ({paymentUrl, paymentQrCode, paymentId}: UpdateParams) => {
      const externalPaymentPartnerParams = {
        payment_url: paymentUrl,
        payment_qr_code: paymentQrCode,
        payment_id: paymentId,
        external_payment_partner: 'crypto_dot_com' as const,
      };

      const response = await updatePayinSessionMutation({
        variables: {
          input: {
            client_secret: clientSecret,
            crypto_payin_session: sessionId,
            external_payment_partner_params: externalPaymentPartnerParams,
          },
        },
      });

      const updatedSession = response.data?.v1CryptoInternalPayinSessionUpdate;

      if (updatedSession) {
        store.setValue((state) => {
          state.state = updatedSession.state;
          state.externalPaymentDetails = convertGraphQlToExternalPaymentDetails(
            updatedSession.external_payment_details,
          );
        });
      }
    },
    [sessionId, clientSecret, updatePayinSessionMutation, store],
  );

  return updateSession;
};
